const DEFAULT_RANGE_DAYS = 30;

/** What the analytics pages show before anyone picks a range. */
export function defaultAnalyticsDateFilter(): [
  Temporal.PlainDate,
  Temporal.PlainDate,
] {
  const today = Temporal.Now.plainDateISO();
  return [today.subtract({ days: DEFAULT_RANGE_DAYS }), today];
}

/** The page picks days; the queries take instants. Both ends land on midnight
 *  so the period before this one lines up against it without a gap. */
export function analyticsDateRange(
  dateFilter: [Temporal.PlainDate, Temporal.PlainDate] | undefined,
): { startDate: Temporal.Instant; endDate: Temporal.Instant } {
  const [from, to] = dateFilter ?? defaultAnalyticsDateFilter();
  return { startDate: midnight(from), endDate: midnight(to) };
}

const midnight = (day: Temporal.PlainDate) =>
  day.toZonedDateTime("UTC").toInstant();
